export const loginSteps = {
    returnToLoginPage: 0,
    inputVerifyCode: 1,
    inputNewPasswordAndVerifyCode: 2,
    inputNewPassword: 3,
    enterSystem: 4
};

export const errorCodes = {
    badParameter: 1,
    invalidUsernameOrPassword: 2,
    inactiveUser: 3,
    lockedUser: 4,
    passwordExpired: 5,
    haveNoPermission: 6,
    invalidToken: 7,
    invalidVerifyCode: 8,
    passwordNotStrong: 10001
};

export function query(selectors) {
    return document.querySelector(selectors);
}

export function queryAll(selectors) {
    return document.querySelectorAll(selectors);
}

export function delay(ms, signal) {
    return new Promise(resolve => {
        signal?.addEventListener('abort', handleAbort);

        const timer = setTimeout(callback, ms);

        function callback() {
            signal?.removeEventListener('abort', handleAbort);
            resolve(timer);
        }

        function handleAbort() {
            clearTimeout(timer);
            throw new DOMException('delay has been canceled.', 'AbortError')
        }
    });
}

export function array2Base64(array) {
    var base64 = btoa(String.fromCharCode(...array));
    return base64.replaceAll('+', '-').replaceAll('/', '_');
}

export function encrypt(password) {
    return Promise.resolve(password);
    // TODO:
    //return crypto.subtle.importKey('jwk', {
    //    alg: 'RSA-OAEP-256',
    //    e: 'AQAB',
    //    ext: true,
    //    key_ops: ['encrypt'],
    //    kty: 'RSA',
    //    n: 'wfQBsZEhGgvSgha9MwEHQUcQO7KXPEvzFL2Ug4m4aVYjNeZUIDXzsBj3y6UsPNhczBqgQT2zKwT6ZYYftW5EopOd4YC6o7lBg_Wty-ayIJfyKKL6-U' +
    //        'nB5DCS2i8jtqNAl4FIvwXf8wK3PvUzijsUxmrYNP6d0WYpmCx5JzssEnIm6Zza6wfC3-fGbBy42lwIaKYR3O-wVSSy6_eoh1lGy67bvx83hoK8jjwF' +
    //        'uahj6Jyh3gRk0v_WYx6lRLi4AISiEpm3FwW-5i9IU0F3fGUZ5hK6I_jAohctuQZnaZTuNMYx4tEWmhOQ370dKevFIjoKW09red0CPZ9XQK25IhFMMQ'
    //}, {
    //    name: 'RSA-OAEP',
    //    hash: 'SHA-256'
    //}, false, ["encrypt"]).then(key => {
    //    const encoded = new TextEncoder().encode(password);
    //    return crypto.subtle.encrypt({ name: 'RSA-OAEP' }, key, encoded);
    //});
}
